import React, { Component, Fragment } from 'react';
import Decorator from '../../../../functions/decorator';

export default class CheckboxSelector extends Component {
    constructor(props) {
        super(props);
        this.select = this.select.bind(this);
        this.increaseQuantity = this.increaseQuantity.bind(this);
        this.decreaseQuantity = this.decreaseQuantity.bind(this);
        this.handleModifierChange = this.handleModifierChange.bind(this);
        this.preventAccidentalRemoval = this.preventAccidentalRemoval.bind(this);
        this.state = {
            quantity: this.props.choice.quantity
        }
    }

    isSelected() {
        if(this.props.choice.quantity > 0) {
            return true;
        }
        return false;
    }

    select() {
        if(this.isSelected()) {
            this.props.removeModifier(this.props.modifierKey);
        }else {
            this.props.select(this.props.modifierKey);
        }
    }

    increaseQuantity(e) {
        this.props.increaseModifierQuantity(this.props.modifierKey);
        e.stopPropagation();
    }

    decreaseQuantity(e) {
        this.props.decreaseModifierQuantity(this.props.modifierKey);
        e.stopPropagation();
    }

    handleModifierChange(changeEvent) {
        this.props.handleModifierQuantityChange(changeEvent, this.props.modifierKey);
        changeEvent.stopPropagation();
    }

    preventAccidentalRemoval(e) {
        e.stopPropagation();
    }

    render() {
        let isSelected = this.props.choice.quantity > 0;
        return (
            <div className={`card checkbox-card clickable-element text-center`}>
                <div className="card-body">
                    <h5 className={`card-title ${isSelected ? 'store-fg-accent' : ''}`}>{Decorator.capitalizeFirst(this.props.name)}</h5>
                </div>
                
                {this.isSelected() && this.props.maxQuantity != 1 ? ( // Show this only if maxQuantity allows for it
                    <Fragment>
                        <div className='card-body'>
                            <div className="btn-group">
                                <button className="btn btn-primary"><span className='h4' onClick={this.decreaseQuantity}>-</span></button>
                                <button disabled className="btn-default disabled">{this.props.choice.quantity}</button>
                                <button className="btn btn-primary"><span className='h4' onClick={this.increaseQuantity}>+</span></button>
                            </div>
                        </div>
                        <div className="card-body text-center">
                            <button onClick={this.select} className="btn btn-accent">Remove</button>
                        </div>
                    </Fragment>
                ) : (
                    <div className="card-body text-center">
                        <button  onClick={this.select} className="btn btn-accent">Add</button>
                    </div>
                )}
            </div>
        );
    }
}